<template>
    <div class="main-container type">
        <div class="people-error" role="alert" v-if="status === 'ad_type_errors'">
            <div class="alert-badge">
                <i class="far fa-exclamation-triangle"></i>
            </div>
            <div class="alert-details">
                <p class="alert-message">
                    {{ error_message }}
                </p>
            </div>
            <ul class="error-items" v-if="ad_type_errors">
                <li v-for="error in ad_type_errors">{{ error }}</li>
            </ul>
        </div>
        <div class="people-container p-5">
            <div class="format">
                <h2 class="text-center font-normal">Select the announcement format</h2>
                <div class="format-options">
                    <div :class="['format-option', { selected: ad_type === 'standard_feature' }]">
                        <h3 class="text-center">Standard</h3>
                        <ul>
                            <li></li>
                            <li class="included"><i class="fa-duotone fa-circle-check"></i>Name, Photo, Job Title</li>
                            <li class="included"><i class="fa-duotone fa-circle-check"></i>Profile Description</li>
                            <li class="excluded"><i class="fa-duotone fa-circle-xmark"></i>Premium Size &amp; Placement
                            </li>
                            <li class="excluded"><i class="fa-duotone fa-circle-xmark"></i>Company Description &amp;
                                Link</li>
                            <li class="excluded"><i class="fa-duotone fa-circle-xmark"></i>Company Branding</li>
                        </ul>
                        <button class="primary-outline sm w-full" v-on:click="ad_type = 'standard_feature'">
                            {{ ad_type === "standard_feature" ? "Selected" : "Select" }}
                        </button>
                    </div>
                    <div :class="['format-option', 'best-value', { selected: ad_type === 'spotlight_feature' }]">
                        <h3 class="text-center">Spotlight</h3>
                        <ul>
                            <li>Best Value</li>
                            <li class="included"><i class="fa-duotone fa-circle-check"></i>Name, Photo, Job Title</li>
                            <li class="included"><i class="fa-duotone fa-circle-check"></i>Profile Description</li>
                            <li class="included"><i class="fa-duotone fa-circle-check"></i>Premium Size &amp; Placement
                            </li>
                            <li class="included"><i class="fa-duotone fa-circle-check"></i>Company Description &amp;
                                Link</li>
                            <li class="excluded"><i class="fa-duotone fa-circle-xmark"></i>Company Branding</li>
                        </ul>
                        <button class="primary sm w-full" v-on:click="ad_type = 'spotlight_feature'">
                            {{ ad_type === "spotlight_feature" ? "Selected" : "Select" }}
                        </button>
                    </div>
                    <div :class="['format-option', { selected: ad_type === 'spotlight_feature_logo' }]">
                        <h3 class="text-center">Spotlight + Logo</h3>
                        <ul>
                            <li></li>
                            <li class="included"><i class="fa-duotone fa-circle-check"></i>Name, Photo, Job Title</li>
                            <li class="included"><i class="fa-duotone fa-circle-check"></i>Profile Description</li>
                            <li class="included"><i class="fa-duotone fa-circle-check"></i>Premium Size &amp; Placement
                            </li>
                            <li class="included"><i class="fa-duotone fa-circle-check"></i>Company Description &amp;
                                Link</li>
                            <li class="included"><i class="fa-duotone fa-circle-check"></i>Company Branding</li>
                        </ul>
                        <button class="primary-outline sm w-full" v-on:click="ad_type = 'spotlight_feature_logo'">
                            {{ ad_type === "spotlight_feature_logo" ? "Selected" : "Select" }}
                        </button>
                    </div>
                </div>
            </div>
            <div class="channels">
                <h2 class="text-center font-normal">Select the distribution channels for your announcement</h2>
                <div class="channel-head">
                    <div>Channel</div>
                    <div class="text-center">Selection</div>
                    <div class="text-right">Pricing</div>
                </div>
                <div class="channel-options">
                    <div class="channel-option">
                        <div class="channel-name">
                            <img src="https://cdn.ibj.com/wp-content/uploads/2022/07/people-online.png" alt="" />
                            IBJ.com
                        </div>
                        <div class="text-center">Included</div>
                        <div class="text-right">$0</div>
                    </div>
                    <div class="channel-option">
                        <div class="channel-name">
                            <img src="https://cdn.ibj.com/wp-content/uploads/2022/07/people-print.png" alt="" /> IBJ
                            Print
                        </div>
                        <div class="text-center">
                            <v-switch v-model="channels.print.selected" :disabled="ad_type != 'standard_feature'" inset
                                hide-details></v-switch>
                        </div>
                        <div class="text-right">{{ currancy.format(current_print_price) }}</div>
                    </div>
                    <div class="channel-option">
                        <div class="channel-name">
                            <img src="https://cdn.ibj.com/wp-content/uploads/2022/07/people-online.png" alt="" /> IBJ
                            Newsletters
                        </div>
                        <div class="text-center"><v-switch v-model="channels.newsletters.selected" inset
                                hide-details></v-switch></div>
                        <div class="text-center"></div>
                    </div>
                    <div class="newsletters" v-if="channels.newsletters.selected">
                        <div class="newsletter channel-option"
                            v-for="(newsletter, key) in channels.newsletters.products" :key="newsletter.key">
                            <div>
                                <img :class="newsletter.name" :src="logos[newsletter.name].image"
                                    :alt="newsletter.title" />
                                <small>{{ logos[newsletter.name].type }}</small>
                            </div>
                            <div class="text-center"><v-switch v-model="newsletter.selected" inset
                                    hide-details></v-switch></div>
                            <div class="text-right">{{ currancy.format(newsletter.prices[pricing]) }}</div>
                        </div>
                    </div>
                    <div class="channel-option total-container">
                        <div class="channel-name"></div>
                        <div class="text-right"></div>
                        <div class="text-right total">
                            <span>{{ currancy.format(total) }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex justify-end items-center">
            <button class="primary" v-on:click="saveAdType" :disabled="status === 'processing_ad_type'">
                <i class="fad fa-spinner-third fa-spin" v-if="status === 'processing_ad_type'"></i>
                {{ status === "processing_ad_type" ? "Processing" : "Continue" }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: "AdTypeView",
    props: ["account"],
    data() {
        return {
            ad_type: localStorage.getItem("people_ad_type") ? localStorage.getItem("people_ad_type") : "spotlight_feature",
            channels: {
                website: {
                    name: "IBJ.com",
                    selected: true,
                },
                print: {
                    name: "IBJ Print",
                    selected: true,
                    products: [],
                },
                newsletters: {
                    name: "IBJ Newsletters",
                    selected: false,
                    products: [],
                },
            },
            current_print_price: null,
            pricing: is_paid_subscriber ? "discount" : "standard",
            total: 0,
            order_item: {
                products: [],
                total: 0,
                pricing: "",
                ad_type: "",
                person: {},
            },
            logos: {
                ibj_daily: { image: "https://www.ibj.com/wp-content/themes/ibj/images/ibj-logos/ibj-daily.png", type: "" },
                ibj_real_estate_weekly: {
                    image: "https://www.ibj.com/wp-content/themes/ibj/images/ibj-logos/ibj-real-estate-weekly.png",
                    type: "",
                },
                ibj_health_care_weekly: {
                    image: "https://www.ibj.com/wp-content/uploads/2025/01/life-sciences-health-care-logo.png",
                    type: "",
                },
                ibj_tech: { image: "https://www.ibj.com/wp-content/themes/ibj/images/ibj-logos/ibj-tech.png", type: "" },
                north_of_96th: {
                    image: "https://www.ibj.com/wp-content/themes/ibj/images/ibj-logos/ibj-north-of-96th.png",
                    type: "EXCLUSIVE CONTENT",
                },
            },
            currancy: new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
            }),
            status: null,
            ad_type_errors: null,
        };
    },
    mounted() {
        this.emitter.emit("updateProgress", { step: 1 });
        localStorage.people_ad_type = this.ad_type;
        this.setProducts();
        this.updatePricing();
    },
    watch: {
        ad_type(newValue, oldValue) {
            localStorage.people_ad_type = newValue;

            if (newValue != "standard_feature") {
                this.channels.print.selected = true;
            }

            this.updatePricing();
        },
        account(newValue, oldValue) {
            this.setProducts();
            this.updatePricing();
        },
        channels: {
            deep: true,
            handler(newValue, oldValue) {
                this.updatePricing();
                this.saveChannels();
            },
        },
        pricing(newValue, oldValue) {
            this.updatePricing();
        },
    },
    methods: {
        updatePricing() {
            this.total = 0;
            this.order_item.products = [];

            if (this.channels.print.selected) {
                this.channels.print.products.forEach((product) => {
                    if (product.name.replace("ibj_print_", "") === this.ad_type) {
                        this.total += parseInt(product.prices[this.pricing]);
                        this.order_item.products.push(product.id);
                    }
                });
            }

            if (this.channels.newsletters.selected) {
                this.channels.newsletters.products.forEach((product) => {
                    if (product.selected) {
                        this.total += parseInt(product.prices[this.pricing]);
                        this.order_item.products.push(product.id);
                    }
                });
            }

            this.channels.print.products.forEach((product) => {
                if (product.name.replace("ibj_print_", "") === this.ad_type) {
                    this.current_print_price = parseInt(product.prices[this.pricing]).toFixed(2);
                }
            });
        },
        setProducts() {
            if (this.account) {
                this.account.products.forEach((product) => {
                    if (!product.is_newsletter) {
                        this.channels.print.products.push({
                            id: product.id,
                            name: product.label,
                            prices: {
                                standard: parseInt(product.amount),
                                discount: parseInt(product.discount_amount),
                            },
                        });
                    } else {
                        this.channels.newsletters.products.push({
                            id: product.id,
                            name: product.label,
                            title: product.name,
                            selected: false,
                            prices: {
                                standard: parseInt(product.amount),
                                discount: parseInt(product.discount_amount),
                            },
                        });
                    }
                });
            }

            if (localStorage.getItem("people_channels")) {
                this.channels = JSON.parse(localStorage.getItem("people_channels"));
            }
        },
        saveChannels() {
            localStorage.people_channels = JSON.stringify(this.channels);

            this.order_item.total = this.total;
            this.order_item.ad_type = this.ad_type;
            this.order_item.pricing = this.pricing;

            localStorage.people_order_item = JSON.stringify(this.order_item);
        },
        saveAdType() {
            this.status = "processing_ad_type";

            if (this.order_item.products.length === 0) {
                this.status = "ad_type_errors";
                this.error_message = "Oops, we have a problem:";
                this.ad_type_errors = ["Please select at least one channel. Not including IBJ.com."];
                scroll(0, 0);
                return;
            }

            this.order_item.total = this.total;
            this.order_item.ad_type = this.ad_type;
            this.order_item.pricing = this.pricing;

            localStorage.people_order_item = JSON.stringify(this.order_item);

            const router = this.$router;

            router.push("/add-ons");
        },
    },
};
</script>

<style>
.format-options {
    display: flex;
    align-items: flex-end;
    gap: 20px;
    width: 100%;
}

@media screen and (max-width: 599px) {
    .format-options {
        flex-direction: column;
        align-items: center;
    }
}

.format {
    margin-bottom: 40px;
    padding-bottom: 40px;
    border-bottom: solid 1px #999999;
}

.format-option {
    width: 33.33%;
}

@media screen and (max-width: 599px) {
    .format-option {
        width: 100%;
        max-width: 300px;
    }
}

.format-options ul {
    list-style: none;
    margin: 0 0 12px 0;
    background-color: #e9eaee;
    border-radius: 10px;
    border: solid 2px #d9d9d9;
}

.format-options li {
    font-size: 14px;
    line-height: 1;
    padding: 10px 6px;
    border-bottom: solid 1px #d9d9d9;
    min-height: 41px;
    display: flex;
    align-items: center;
}

.format-options li:last-child {
    border-bottom: none;
    margin-block: 0;
}

.format-options .best-value ul {
    background-color: #fff6ea;
}

.format-options .selected ul {
    border: solid 2px #3490dc;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.5);
}

.format-options .best-value li:first-child {
    background-color: #3490dc;
    color: #ffffff;
    font-weight: 700;
    border-radius: 8px 8px 0 0;
    font-size: 16px;
    justify-content: center;
}

.format-options .selected.best-value li:first-child {
    border-radius: 4px 4px 0 0;
}

.best-value h3 {
    color: #3490dc;
}

.format-option i {
    font-size: 16px;
    margin-right: 6px;
}

.format-option .included {
    color: #005caf;
}

.format-option .excluded {
    color: #666666;
    text-decoration: line-through;
}

.channel-head {
    background-color: #e4e3e2;
    display: flex;
    gap: 20px;
    padding: 6px 12px;
    font-weight: 700;
}

.channel-head div {
    width: 33.33%;
}

.channel-options {
    padding: 12px;
}

.newsletter.channel-option>div {
    margin-bottom: 0;
}

.channel-option {
    display: flex;
    gap: 20px;
    align-items: center;
    font-weight: 700;
    min-height: 56px;
}

.channel-option>div {
    width: 33.33%;
    margin-bottom: 12px;
}

.channel-option.total-container {
    min-height: auto;
}

.channel-option.total-container>div {
    margin-bottom: 0;
}

.channel-name {
    display: flex;
    align-items: center;
}

.channel-name img {
    width: 100%;
    max-width: 80px;
    margin-right: 12px;
}

@media screen and (max-width: 599px) {
    .channel-name img {
        display: none;
    }
}

.v-switch {
    width: 48px;
    margin: auto;
}

.newsletters {
    background-color: #f2f2f2;
    padding: 8px 12px 12px 12px;
    margin-left: -12px;
    margin-bottom: 12px;
    width: calc(100% + 24px);
}

img.ibj_daily {
    max-height: 38px;
    display: block;
}

img.ibj_real_estate_weekly {
    max-height: 38px;
    display: block;
}

img.ibj_health_care_weekly {
    max-height: 38px;
    display: block;
}

img.ibj_tech {
    max-height: 36px;
    display: block;
}

img.north_of_96th {
    max-height: 54px;
    display: block;
}

.total {
    font-weight: 700;
}

.total span::before {
    content: "Total:";
    position: absolute;
    left: -46px;
    color: #000000;
}

.total span {
    color: #1f9d55;
    display: inline-block;
    position: relative;
}
</style>
